module.exports = __webpack_public_path__ + "img/Screenshot 2023-06-19 at 11.40.20.1ddab48f.jpg";